export const ROUTE_LOGIN = "/";
export const ROUTE_THANK_YOU = "/thankYou";
export const ROUTE_DOTAZNIK = "/dotaznik";
export const ROUTE_EXPIRED = "/expired";
export const ROUTE_INVALID = "/invalid";
export const ROUTE_TECHNICALISSUE = "/technical-issue";
export const ROUTE_MAINTENANCE = "/maintenance";
export const ROUTE_COOKIES = "/cookies";